<template>
  <footer>
    <img src="../assets/images/icons/logo-light.svg" alt="logo" class="footer-logo">
    <div class="footer-box">

      <div class="left-footer-box">

        <div class="contact-details"><img src="../assets/images/icons/location.svg" alt="address"><span>Address Line 1,
            <br> City, State name, <br> Country.</span></div>
        <div class="contact-details"><img src="../assets/images/icons/mail.svg"
            alt="email"><span>admin@codedevents.com</span></div>
        <div class="contact-details"><img src="../assets/images/icons/mobile.svg"
            alt="telephone"><span>080665533556</span></div>

        <div class="social-media-icons">
          <div><img src="../assets/images/icons/facebook.svg" alt="facebook"></div>
          <div><img src="../assets/images/icons/facebook.svg" alt="twitter"></div>
          <div><img src="../assets/images/icons/facebook.svg" alt="instagram"></div>
          <div><img src="../assets/images/icons/facebook.svg" alt="whatsapp"></div>
        </div>
        <div>
          <p class="copyright">@codedevents 2021</p>
        </div>
      </div>

      <div class="middle-footer-box">
        <h2 class="company-name">Company</h2>
        <ul>
          <li>Home</li>
          <li>Pricing</li>
          <li>Create Event</li>
          <li>About</li>
          <li>Blog</li>
          <li>Contact</li>
        </ul>
      </div>

      <div class="right-footer-box">
        <h2 class="join-newsletter">Join A NewsLetter !</h2>
        <p class="email-text">Your Email</p>
        <input type="text" class="email-input">
        <button class="join-button">Join</button>
      </div>
    </div>
  </footer>
</template>
